import styled from 'styled-components'

export const Caption = styled.span`
	margin-left: 32px;
	font-size: 13px;
	opacity: 0.6;
`
